(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curadoria-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[id^="CuradoriaSlideshow-"]');
    if (!root) return;
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = [...root.querySelectorAll('[data-dot]')];
    let current = 0;
    let timer = null;
    let touchStart = 0;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
    };

    const start = () => {
      if (timer) clearInterval(timer);
      if (root.dataset.autoplay === 'true' && slides.length > 1) {
        timer = setInterval(() => show(current + 1), Number(root.dataset.speed) || 6000);
      }
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.dot));
        start();
      });
    });

    root.addEventListener(
      'touchstart',
      (event) => {
        touchStart = event.changedTouches[0].clientX;
        if (timer) clearInterval(timer);
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      (event) => {
        const movement = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(movement) > 45) show(current + (movement < 0 ? 1 : -1));
        start();
      },
      { passive: true }
    );

    show(0);
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ju-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const panels = [...root.querySelectorAll('[data-ju-panel]')];
      const tabs = [...root.querySelectorAll('[data-ju-tab]')];
      const show = (index) => {
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        tabs.forEach((tab, i) => { tab.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => { event.preventDefault(); show(index); });
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); show(next); tabs[next].focus(); }
        });
      });
      root.addEventListener('shopify:block:select', (event) => {
        const index = panels.findIndex((panel) => panel === event.target || panel.contains(event.target));
        if (index >= 0) show(index);
      });
      show(0);
    };
    document.querySelectorAll('[data-ju-editorial]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ju-editorial]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
